import { t } from 'i18next'

import * as yup from 'yup'

/**
 * Form constants
 */

const FACE = 'face'
const EYES = 'eyes'
const BROWS = 'brows'
const NOSE = 'nose'
const LIPS = 'lips'
const QUESTIONS = 'questions'
const ANSWERS = 'answers'

/**
 * Form model
 */
const formModel = () => {
  return {
    [FACE]: {
      label: `${t('student.face')}`,
      name: FACE,
    },
    [EYES]: {
      label: `${t('student.eyes')}`,
      name: EYES,
    },
    [BROWS]: {
      label: `${t('student.brows')}`,
      name: BROWS,
    },
    [NOSE]: {
      label: `${t('student.nose')}`,
      name: NOSE,
    },
    [LIPS]: {
      label: `${t('student.smile')}`,
      name: LIPS,
    },
    [QUESTIONS]: {
      label: `${t('student.questions')}`,
      name: QUESTIONS,
    },
    [ANSWERS]: {
      label: `${t('student.answers')}`,
      name: ANSWERS,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [FACE]: {id: null, url: ''},
  [EYES]: {id: null, url: ''},
  [BROWS]: {id: null, url: ''},
  [NOSE]: {id: null, url: ''},
  [LIPS]: {id: null, url: ''},
  [QUESTIONS]: [],
  [ANSWERS]:  [],

}
/**
 * Form data validation
 */
export const validationSchema = () => yup.object().shape({
})

export default formModel
